const NewLeadList = [
  {
    customerID: 1,
    customerName: "Aniket",
    mobile: "9623576236",
    address: "WOWInfotech Aniket",
    mail: "abc123@gmail.com",
  },
  {
    customerID: 2,
    customerName: "Ganesh",
    mobile: "9623576255",
    address: "WOW Infotech Ganesh ",
    mail: "ganesh123@gmail.com",
  },
  {
    customerID: 3,
    customerName: "Sandip",
    mobile: "9623577736",
    address: "WOWInfotech Sandip",
    mail: "sandip123@gmail.com",
  },
];
const CalenderFilter = [
  {
    value: 0,
    label: "Select Dates",
  },
  {
    value: 1,
    label: "This Week",
  },
  // {
  //   value: 2,
  //   label: "Last Week",
  // },
  {
    value: 3,
    label: "This Month",
  },
  // {
  //   value: 4,
  //   label: "Last Month",
  // },
  // {
  //   value: 5,
  //   label: "This Quarter",
  // },
  // {
  //   value: 6,
  //   label: "Last Quarter",
  // },
  // {
  //   value: 7,
  //   label: "This 6 Months",
  // },
  // {
  //   value: 8,
  //   label: "Last 6 Months",
  // },
  {
    value: 9,
    label: "This Year",
  },
  // {
  //   value: 10,
  //   label: "Last Year",
  // },
  {
    value: 11,
    label: "Custom Date",
  },
];

const MIDC = [
  { value: 1, label: "Satpur" },
  { value: 2, label: "Ambad" },
  { value: 3, label: "Sinner" },
];
const Source = [
  { value: 1, label: "Facebook" },
  { value: 2, label: "Instagram" },
  { value: 3, label: "WebSite" },
  { value: 4, label: "other" },
];
const Status = [
  { value: 1, label: "Hot" },
  { value: 2, label: "Warm" },
  { value: 3, label: "Cold" },
];
const Product = [
  { value: 1, label: "Product 1" },
  { value: 2, label: "Product 2" },
  { value: 3, label: "Product 3" },
];
const leadStages = [
  { value: 1, label: "Sales Log" },
  { value: 2, label: "Account Log" },
  { value: 3, label: "DVR Lead Log" },
];
const SalesmanList = [
  { value: 1, label: "Chanchal" },
  { value: 2, label: "Account Log" },
  { value: 3, label: "DVR Lead Log" },
];
const LoginResponse = {
  statusCode: 400,
  errorMessage: "User Not Exists or Found.",
  totalCount: 0,
  responseData: null,
};
const unitList = [
  { value: 1, label: "unit 1" },
  { value: 2, label: "unit 2" },
  { value: 3, label: "unit 3" },
];

const quotationFormatList = [
  { value: 1, label: "Projects" },
  { value: 2, label: "Trading" },
];

const stateList = [
  { value: 1, label: "Maharashtra" },
  { value: 2, label: "Punjab" },
  { value: 3, label: "UP" },
];
const districtList = [
  { value: 1, label: "Nashik", stateID: 1 },
  { value: 2, label: "Ludhiana", stateID: 2 },
  { value: 3, label: "Prayagraj", stateID: 3 },
  { value: 4, label: "Pune", stateID: 1 },
];
const talukaList = [
  { value: 1, label: "Dindori", districtID: 1 },
  { value: 2, label: "Ludhiana taluka 1", districtID: 2 },
  { value: 3, label: "Prayagraj taluka 1 ", districtID: 3 },
  { value: 4, label: "KATRAJ", districtID: 4 },
];
const statusList = [
  { value: 1, label: "First Intro" },
  { value: 2, label: "Profile Shared" },
  { value: 3, label: "Enquiry Received" },
];
const followupStatusList = [
  { value: 1, label: "Completed" },
  { value: 2, label: "Cancelled" },
];
const enquiryChangeStatusList = [
  { value: 4, label: "Loose" },
  { value: 5, label: "Regret" },
  { value: 6, label: "Yet to quote" },
  { value: 7, label: "Hold by client" },
  { value: 8, label: "Est & Boq" },
  // { value: 9, label: 'PO Received' }
];

const quotationChangeStatusList = [
  { value: 4, label: "Loose" },
  { value: 5, label: "Regret" },
  { value: 7, label: "Hold by client" },
  { value: 9, label: "PO Received" },
];
const typeList = [
  { value: 1, label: "Service" },
  { value: 2, label: "Supply" },
  { value: 3, label: "Services & Supply" },
  { value: 4, label: "Other" },
];

const userTypeList = [
  { value: 1, label: "Admin User" },
  { value: 2, label: "CRM User" },

];

const TermsAndConditionTypeList = [
  { value: 1, label: "Payment & Delivery Terms and Condition" },
  { value: 2, label: "Details Terms and Condition" },

];
const fieldReportFilterList = [
  { value: 0, label: 'All' },
  { value: 1, label: 'Present' },
  { value: 2, label: 'Absent' },

];
export default {
  NewLeadList,
  CalenderFilter,
  MIDC,
  Source,
  Status,
  Product,
  leadStages,
  LoginResponse,
  SalesmanList,
  unitList,
  quotationFormatList,
  stateList,
  districtList,
  talukaList,
  statusList,
  typeList,
  followupStatusList,
  enquiryChangeStatusList,
  quotationChangeStatusList, userTypeList, TermsAndConditionTypeList, fieldReportFilterList
};
